import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-176">
      {/* Background Video with Fallback */}
      <div className="absolute inset-0 w-full h-full" data-id="element-177">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-178">
          <source src="https://cdn.pixabay.com/video/2022/11/14/139017-771444632_large.mp4" type="video/mp4" data-id="element-179" />
        </video>
        {/* Fallback background image */}
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80')"
      }} data-id="element-180" />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628]/80 to-[#1b2b45]/80 z-10" data-id="element-181"></div>
      </div>
      {/* Subtle geometric lines */}
      <div className="absolute inset-0 opacity-10 z-20" data-id="element-182">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-183">
          <defs data-id="element-184">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-185">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#d4af37" strokeWidth="0.5" data-id="element-186" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-187" />
        </svg>
      </div>
      {/* Content */}
      <div className="relative z-30 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-12" data-id="element-188">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight" data-id="element-189">
          Premium Renovations for{' '}
          <span className="text-[#d4af37]" data-id="element-190">Modern Living</span>
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-200 mb-8 sm:mb-10 max-w-3xl mx-auto px-4" data-id="element-191">
          Transforming Brisbane homes with style, precision, and innovation
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-192">
          <Link to="contact" smooth={true} duration={500} className="inline-flex items-center gap-2 bg-[#d4af37] text-[#0a1628] px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 transform hover:scale-105 cursor-pointer border border-[#d4af37] active:scale-95" data-id="element-193">
            Get a Free Quote
            <ArrowRightIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-194" />
          </Link>
          <Link to="services" smooth={true} duration={500} className="inline-flex items-center gap-2 bg-transparent text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold border border-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a1628] transition-all duration-300 transform hover:scale-105 cursor-pointer active:scale-95" data-id="element-195">
            View Services
          </Link>
        </motion.div>
      </div>
      {/* Scroll Indicator - Hidden on mobile */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1
    }} className="hidden md:block absolute bottom-10 left-1/2 transform -translate-x-1/2 z-30" data-id="element-196">
        <div className="w-6 h-10 border-2 border-[#d4af37] rounded-full flex items-start justify-center p-2" data-id="element-197">
          <motion.div animate={{
          y: [0, 12, 0]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="w-1 h-2 bg-[#d4af37] rounded-full" data-id="element-198" />
        </div>
      </motion.div>
    </section>;
}